import React from 'react';
import { useLanguage } from '../i18n';

const AboutUsModal = ({ open, onClose }) => {
  const { t } = useLanguage();

  if (!open) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <div className="popup-header">
          <h2>{t('aboutUs_title')}</h2>
          <button className="popup-close" onClick={onClose} aria-label={t('close')}>
            ×
          </button>
        </div>
        <div className="popup-body">
          <div className="tip-item">
            <div className="tip-text">
              <p className="about-us-intro" style={{ fontWeight: 'bold', fontSize: '1.1em', marginBottom: '1em' }}>
                {t('aboutUs_intro')}
              </p>
              <p style={{ whiteSpace: 'pre-line' }}>{t('aboutUs_description')}</p>
            </div>
          </div>

          <div className="tip-item">
            <div className="tip-text">
              <h3>{t('aboutUs_whatWeDo_title')}</h3>
              <p style={{ whiteSpace: 'pre-line' }}>{t('aboutUs_whatWeDo_content')}</p>
            </div>
          </div>

          <div className="tip-item">
            <div className="tip-text">
              <h3>{t('aboutUs_mission_title')}</h3>
              <p style={{ whiteSpace: 'pre-line' }}>{t('aboutUs_mission_content')}</p>
            </div>
          </div>

          <div className="tip-item">
            <div className="tip-text">
              <h3>{t('aboutUs_forWhom_title')}</h3>
              <p style={{ whiteSpace: 'pre-line' }}>{t('aboutUs_forWhom_content')}</p>
            </div>
          </div>

          <div className="tip-item">
            <div className="tip-text">
              <h3>{t('aboutUs_whyChooseUs_title')}</h3>
              <p style={{ whiteSpace: 'pre-line' }}>{t('aboutUs_whyChooseUs_content')}</p>
            </div>
          </div>

          <div className="tip-item">
            <div className="tip-text">
              <h3>{t('aboutUs_future_title')}</h3>
              <p style={{ whiteSpace: 'pre-line' }}>{t('aboutUs_future_content')}</p>
            </div>
          </div>

          <div className="tip-item">
            <div className="tip-text">
              <h3>{t('aboutUs_contact_title')}</h3>
              <p style={{ whiteSpace: 'pre-line' }}>{t('aboutUs_contact_content')}</p>
            </div>
          </div>
        </div>
        <div className="popup-footer">
          <button className="btn-primary" onClick={onClose}>
            {t('close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutUsModal;